export default "__VITE_ASSET__Bc1Od0nq__"